import { jsonParseSafe } from "../../../common/json";
import { win } from "../../../common/namespaces.js";

/**
 *
 */
interface OnexDataRaw {
  onexes?: (OnexEntryRaw | undefined)[];
}

interface OnexEntryRaw {
  n: string;
  v: string;
}

declare global {
  interface Window {
    /**
 *
 *
 */
    __onex__?: App.Onex;

    /**
 *
 */
    __onex_raw__?: OnexDataRaw;
  }
}

/**
 *
 *
 *
 *
 *
 */
export function transformAndAssignOnexData<R extends App.Onex | undefined>(
  data: OnexDataRaw | undefined | null = win.__onex_raw__,
  defaultValue: R = undefined as R,
): R {
  /*                                                        */
  if (!data) return defaultValue;

  /*                                             */
  const { onexes = [] } = data;
  const onexData = Object.fromEntries(
    onexes.map((onex) => (onex ? ([onex.n, onex.v] as const) : undefined)).filter(Boolean),
  ) as App.Onex;

  /*                                                                             */
  win.__onex__ = onexData;
  return onexData as R;
}

/**
 *
 *
 *
 *
 *
 */
export async function fetchOnexData(): Promise<void> {
  /*                                        */
  if (win.__onex__) return;

  const response = await fetch(new URL("/onex/assignments/", win.location.href));
  if (!response.ok) return;
  const text = await response.text();
  const data = jsonParseSafe<OnexDataRaw>(text);

  /*                                                    */
  otto.onex.assignments.set(transformAndAssignOnexData(data, {} as App.Onex));
}
